import { ActionType } from "../actions/actionTypes";

type ProviderState = {
  allProviders?: Provider[];
};

const INITIAL_STATE: ProviderState = {
  allProviders: []
};

export default (state = INITIAL_STATE, action: ActionType): ProviderState => {
  switch (action.type) {
    case "FETCH_PROVIDERS_SUCCESS": {
      return { ...state, ...action.payload };
    }
    default:
      return state;
  }
};
